<mat-card class="p-3">
  <h1 *ngIf="data.title" mat-dialog-title class="label">{{ data.title }}</h1>
  <mat-dialog-content>
    <p class="py-2 form-dialog-subtitle" *ngIf="data?.subTitle">
      {{ data.subTitle }}
    </p>
  </mat-dialog-content>
  <ng-container [ngComponentOutlet]="data.content"></ng-container>
</mat-card>
